import React from 'react'
import { BuyerEditFormStyle } from './styled'
import {
  Button,
  Image,
  Input,
  Section,
  SelectBox,
  Switcher,
  InputTextarea,
  Spinner,
} from '../../components'
import { EMAIL_REGEX } from 'helpers'
import { ICONS } from '../../themes'
import { buyermangeController, countryController } from '../../apiService'
import { ROUTE_PATH, redirect, STRING } from '../../helpers'
import { toastActive } from '../../helpers/functions/toastSuccess'
import { toastFail } from '../../helpers/functions/toastFail'

export class BuyerEditFormContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      optionsCountry: [{ value: 'Thailand', label: 'Thailand' }],
      isEditPageState: true,
      canSave: true,
      checkTax: true,
      checkVerify: false,
      BuyerListLoading: false,
      requireTax: false,
      statusVerify: '',
      tax_id: '',
      company_name: '',
      regis_address: '',
      regis_country: '',
      contact_address: '',
      contact_country: {},
      phone: '',
      fax: '',
      email: '',
      website: '',
      supplier_portal: '',
      admin_buyer_full_name: '',
      admin_buyer_email: '',
      admin_buyer_license: '',
      remain_license: '',
      license: '',
      buyer_id: null,

      emailValid: true,
      admin_buyer_emailValid: true,
      admin_buyer_licenseValidate: true,
      tax_idValidate: true,
      resendEmail: false,
      verify: false,
      requireActive: false,
      saveStatus: true,
      acountStatus: null,
      formValid: true,

      //loading
      resendEmailLoading: false,
      loading: false,
      verifyLoading: false,

      //disable
      disabledToggle: false,
      clickResendmail: false,
      is_active: false,
    }
  }

  componentDidMount() {
    this.getCountryList()
    let url = window.location.pathname
    let id = url.substring(url.lastIndexOf(':') + 1)

    this.setState({
      buyer_id: id,
    })

    this._fetchgetBuyer(parseInt(id))
  }

  _fetchverifyTaxID(id) {
    this.setState({ BuyerListLoading: true, verifyLoading: true })
    return buyermangeController()
      .verifyTaxID(id)
      .then(res => {
        this.company(res)
        this.setState({ BuyerListLoading: false, verifyLoading: false })
      })
      .finally(() => this.setState({ BuyerListLoading: false }))
  }

  company = e => {
    const rows = Array.isArray(e) ? e : e && Array.isArray(e.data) ? e.data : []
    const data = rows[0]
    if (data && data.JP_TNAME) {
      this.setState({
        company_name: data.JP_TNAME,
        canSave: true,
        checkTax: true,
      })
      return
    }
    this.setState({ canSave: false, checkTax: false })
  }

  _fetchgetBuyer(id) {
    this.setState({ BuyerListLoading: true })
    return buyermangeController()
      .getBuyer(id)
      .then(res => {
        this.setState({ BuyerListLoading: false })
        this.mapBuyer(res)
      })
      .catch(err => console.log('err', err))
      .finally(() => this.setState({ BuyerListLoading: false }))
  }

  getCountryList = async () => {
    try {
      const countryList = await countryController().getListCountry()
      if (countryList) {
        const mapCountryList = countryList.map(country => {
          return { value: country.name, label: country.name, id: country.id }
        })
        this.setState({
          optionsCountry: mapCountryList,
        })
      }
    } catch (error) {
      throw error
    }
  }

  resendEmail = () => {
    let data = {
      admin_id: parseInt(this.state.buyer_id),
      email: this.state.admin_buyer_email,
    }
    if (
      this.state.admin_buyer_emailValid &&
      this.state.admin_buyer_email !== ''
    ) {
      this.setState({
        BuyerListLoading: true,
        resendEmailLoading: true,
        formValid: true,
      })
      return buyermangeController()
        .resendEmail(data)
        .then(res => {
          if (res.status === 'EmailDuplicate') {
            toastFail('Email duplicate please change email')
            this.setState({
              BuyerListLoading: false,
              canSave: false,
              resendEmailLoading: false,
            })
          } else if (res.status === 'UpdateSuccess') {
            toastActive('Resent Activation Email')
            this._fetchgetBuyer(this.state.buyer_id)
            this.setState({
              BuyerListLoading: false,
              canSave: true,
              clickResendmail: true,
              acountStatus: 2,
              resendEmailLoading: false,
            })
          } else {
            if (res.message) {
              toastFail(res.message)
            } else {
              toastFail('ERROR')
            }
            this.setState({
              BuyerListLoading: false,
              canSave: false,
              resendEmailLoading: false,
            })
          }
        })
        .finally(() => this.setState({ BuyerListLoading: false }))
    } else {
      this.setState({
        BuyerListLoading: false,
        resendEmailLoading: false,
        formValid: false,
      })
    }
  }

  _fetchupdateBuyer(data) {
    this.setState({ BuyerListLoading: true, loading: true })
    return buyermangeController()
      .updateBuyer(data)
      .then(res => {
        this.setState({ BuyerListLoading: false, loading: false })

        if (res.status === 'UpdateSuccess') {
          this.setState({ BuyerListLoading: false, loading: false })
          setTimeout(
            toastActive('User was updated'),
            this.props.history.push(ROUTE_PATH.BUYER_MANAGEMENT.LINK),
            500
          )
        } else if (res.status === 'TaxIDDuplicate') {
          toastFail('Tax ID duplicate')
          // this.props.history.push(ROUTE_PATH.BUYER_MANAGEMENT.LINK)
        } else {
          if (res.message) {
            toastFail(res.message)
          } else {
            toastFail('ERROR')
          }
        }
      })
      .finally(() => this.setState({ BuyerListLoading: false }))
  }

  mapBuyer = e => {
    const value = e.company || {}
    const country = value.contact_country || {}
    const text = field => (field == null ? '' : String(field))
    const licenseCount =
      e.license || value.license_user_capacity || ''
    this.setState({
      is_active: e.status === 1 ? true : false,
      acountStatus: e.status,
      tax_id: text(value.tax_id),
      company_name: text(value.company_name),
      regis_address: text(value.regis_address),
      regis_country: {
        value: value.regis_country || '',
        label: value.regis_country || '',
      },
      contact_address: text(value.contact_address),
      contact_country: {
        id: country.id,
        value: country.name || '',
        label: country.name || '',
      },
      phone: text(value.phone),
      fax: text(value.fax),
      email: text(value.email),
      website: text(value.website),
      supplier_portal: text(value.supplier_portal),
      admin_buyer_full_name: text(e.full_name),
      admin_buyer_email: text(e.email),
      admin_buyer_license: licenseCount,
      remain_license: e.remain_license || 0,
      license: e.license || value.license_user_capacity || 0,
    })
    const waitActive = e.status === 2
    const inactive = e.status === 0
    if (inactive) {
      this.setState({
        disabledToggle: true,
      })
    }
    if (waitActive) {
      this.setState({
        clickResendmail: true,
        is_active: false,
        disabledToggle: true,
      })
    }
  }

  handleUserInput = e => {
    const { name, value } = e.target

    if (name === 'admin_buyer_email')
      this.setState({ resendEmail: true, canSave: false })

    if (name === 'tax_id') this.setState({ checkVerify: true, canSave: false })

    this.setState({ [name]: value }, () => {
      this.validateField(name, value.trim())
    })
  }

  handleUserDropdown = optionsRole => {
    this.setState({ contact_country: optionsRole }, () => {
      this.validateField(optionsRole.label, optionsRole.value)
    })
  }

  validateField = (fieldName, value) => {
    const re = /^[0-9\b]+$/
    const status = re.test(value)
    const status_email = RegExp(EMAIL_REGEX).test(value)
    let emailValid = this.state.email
    let admin_buyer_emailValid = this.state.admin_buyer_email

    switch (fieldName) {
      case 'tax_id':
        this.setState({ tax_idValidate: status })
        break
      case 'admin_buyer_license':
        this.setState({ admin_buyer_licenseValidate: status })
        break
      case 'email':
        emailValid = RegExp(EMAIL_REGEX).test(value)
        //console.log('emailValid', emailValid)
        this.setState({ emailValid: emailValid })
        break
      case 'admin_buyer_email':
        // this.setState({ admin_buyer_emailValie: status_email })
        // break
        admin_buyer_emailValid = RegExp(EMAIL_REGEX).test(value)
        //console.log('emailValid', emailValid)
        this.setState({ admin_buyer_emailValid: admin_buyer_emailValid })
        break

      default:
        break
    }
  }

  togleSwitchActive = e => {
    if (this.state.clickResendmail) return
    const ACTIVE = 1
    const INACTIVE = 0
    this.setState(prevState => ({
      is_active: !prevState.is_active,
      acountStatus: !prevState.is_active ? ACTIVE : INACTIVE,
    }))
  }

  clickVerify = () => {
    if (this.state.tax_id.trim() !== '') {
      this._fetchverifyTaxID(this.state.tax_id)
      this.setState({ company_name: '' })
    } else {
      this.setState({ requireTax: true })
    }
  }

  onFormSubmit = e => {
    this.setState({ requireActive: true })
    const {
      tax_id,
      company_name,
      regis_address,
      regis_country,
      contact_address,
      contact_country,
      phone,
      fax,
      email,
      website,
      supplier_portal,
      admin_buyer_full_name,
      admin_buyer_email,
      admin_buyer_license,
      buyer_id,
      acountStatus,
      admin_buyer_licenseValidate,
    } = this.state

    let data = {
      id: parseInt(buyer_id),
      tax_id: tax_id.trim(),
      company_name: company_name.trim(),
      // company_name: 'creden'.trim(),
      regis_address: regis_address.trim(),
      regis_country: regis_country.value.trim(),
      contact_address: contact_address.trim(),
      contact_country: parseInt(contact_country.id, 10),
      phone: phone.trim(),
      fax: fax.trim(),
      email: email.trim(),
      website: website.trim(),
      supplier_portal: supplier_portal.trim(),
      admin_buyer_full_name: admin_buyer_full_name.trim(),
      admin_buyer_email: admin_buyer_email.trim(),
      admin_buyer_license: parseInt(admin_buyer_license),
      admin_buyer_status: acountStatus,
    }
    if (
      this.state.admin_buyer_emailValid &&
      this.state.emailValid &&
      data.phone !== '' &&
      data.contact_address &&
      data.email !== '' &&
      data.supplier_portal !== '' &&
      data.admin_buyer_full_name &&
      data.admin_buyer_email &&
      data.admin_buyer_license &&
      data.contact_country &&
      admin_buyer_licenseValidate
    ) {
      this.setState({ formValid: true })
      this._fetchupdateBuyer(data)
    } else {
      this.setState({ formValid: false })
    }
  }

  render() {
    const {
      optionsCountry,
      is_active,
      tax_id,
      company_name,
      regis_address,
      contact_address,
      phone,
      fax,
      email,
      website,
      supplier_portal,
      admin_buyer_full_name,
      admin_buyer_email,
      admin_buyer_license,
      canSave,
      license,
      emailValid,
      admin_buyer_licenseValidate,
      tax_idValidate,
      requireActive,
      remain_license,
      checkTax,
      checkVerify,
      requireTax,
      loading,
    } = this.state

    return (
      <BuyerEditFormStyle>
        {/* PAGE TITLE
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_buyer_management"
                src={ICONS['icon-user-white.svg']}
                alt="page icon"
              />
            </Section>

            <Section className="title-and-breadcrumb">
              <Section id="page_title_buyer_management" className="title">
                {STRING.BUYER_MANAGEMENT}
              </Section>

              <Section
                id="page_breadcrumb_buyer_management"
                className="breadcrumbs"
              >
                <Button
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.HOME.LINK)
                  }}
                  className="breadcrumb"
                >
                  <span>{STRING.HOME}</span>
                </Button>

                <Button
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.BUYER_MANAGEMENT.LINK)
                  }}
                  className="breadcrumb"
                >
                  <span>{STRING.BUYER_MANAGEMENT}</span>
                </Button>

                <Button className="breadcrumb current">
                  <span>Edit Buyer</span>
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>

        {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}

        <Section className="main-content form">
          <Section className="content-body">
            {loading ? (
              <Section className="loading">
                <Spinner />
              </Section>
            ) : (
              <React.Fragment>
                {' '}
                <Section className="form-wrapper">
                  <Section className="form-group-title">Edit Buyer</Section>

                  <Section
                    className={
                      'form-group' +
                      ((tax_id.trim() === '' && requireActive) ||
                      (tax_id.trim() === '' && requireTax)
                        ? ' is-error'
                        : !checkTax
                        ? ' is-error'
                        : !tax_idValidate && requireActive
                        ? ' is-error'
                        : ' ')
                    }
                  >
                    <label>Tax ID</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="tax_id"
                          value={tax_id}
                        />

                        <Button
                          className="theme-blue verify"
                          onClick={() =>
                            !checkVerify ? '' : this.clickVerify()
                          }
                          disabled={!checkVerify}
                        >
                          {!this.state.verifyLoading ? (
                            'Verify'
                          ) : (
                            <span className="loader"></span>
                          )}
                        </Button>
                      </Section>

                      <Section className="message">
                        {(tax_id.trim() === '' && requireActive) ||
                        (tax_id.trim() === '' && requireTax)
                          ? STRING.INVALID
                          : !checkTax
                          ? STRING.TAX_CHECK
                          : !tax_idValidate && requireActive
                          ? STRING.TAX_INVALID
                          : ''}
                      </Section>
                    </Section>
                  </Section>

                  <Section className="form-group">
                    <label>Company Name</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          disabled={true}
                          value={company_name}
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>

                  <Section className="form-row">
                    <Section className="form-col col-6">
                      <Section className="form-group-header">
                        Registered Address
                      </Section>

                      <Section className="form-group">
                        <label>Address</label>

                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <InputTextarea
                              name="regis_address"
                              disabled={true}
                              value={regis_address}
                              onChange={this.handleUserInput}
                            />
                          </Section>

                          <Section className="message"></Section>
                        </Section>
                      </Section>

                      <Section className="form-group">
                        <label>Country</label>

                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <SelectBox
                              id="active_status_filter"
                              value={this.state.regis_country}
                              options={optionsCountry}
                              isSearchable={false}
                              isClearable={false}
                              isDisabled={true}
                            />
                          </Section>

                          <Section className="message"></Section>
                        </Section>
                      </Section>
                    </Section>

                    <Section className="form-col col-6">
                      <Section className="form-group-header grid-to-label">
                        Contact Address
                      </Section>

                      <Section
                        className={
                          'form-group' +
                          (contact_address.trim() === '' ? ' is-error' : '')
                        }
                      >
                        <label>Address</label>

                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <InputTextarea
                              onChange={this.handleUserInput}
                              name="contact_address"
                              value={contact_address}
                              style={
                                contact_address.trim() === '' ? true : false
                              }
                            />
                          </Section>

                          <Section className="message">
                            {contact_address.trim() === '' && requireActive
                              ? STRING.INVALID
                              : ''}
                          </Section>
                        </Section>
                      </Section>

                      <Section className={'form-group'}>
                        <label>Country</label>

                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <SelectBox
                              id="active_status_filter"
                              value={this.state.contact_country}
                              options={optionsCountry}
                              isSearchable={false}
                              isClearable={false}
                              onChange={this.handleUserDropdown}
                              name="contact_country"
                            />
                          </Section>

                          <Section className="message">{''}</Section>
                        </Section>
                      </Section>
                    </Section>
                  </Section>

                  <Section
                    className={
                      'form-group' + (phone.trim() === '' ? ' is-error' : '')
                    }
                  >
                    <label>Phone</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="phone"
                          value={phone}
                        />
                      </Section>

                      <Section className="message">
                        {phone.trim() === '' ? STRING.INVALID : ''}
                      </Section>
                    </Section>
                  </Section>

                  <Section className="form-group">
                    <label>
                      Fax <br /> (Optional)
                    </label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="fax"
                          value={fax}
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>

                  <Section
                    className={
                      'form-group' +
                      (this.state.emailValid
                        ? ''
                        : this.state.formValid
                        ? ''
                        : ' is-error')
                    }
                  >
                    <label>Email</label>

                    <Section className="form-group-control with-button">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="email"
                          value={email}
                          className={
                            this.state.emailValid
                              ? ''
                              : this.state.formValid
                              ? ''
                              : 'is-error'
                          }
                        />
                      </Section>

                      {this.state.email === '' && (
                        <Section className="message">{STRING.INVALID}</Section>
                      )}
                      {!this.state.emailValid && this.state.email !== '' && (
                        <Section className="message">
                          {STRING.EMAIL_INVALID}
                        </Section>
                      )}

                      {this.state.emailValid && this.state.email !== '' && (
                        <Section className="message">{''}</Section>
                      )}
                    </Section>
                  </Section>

                  <Section className={'form-group'}>
                    <label>
                      Website <br /> (Optional)
                    </label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="website"
                          value={website}
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>

                  <Section
                    className={
                      'form-group' +
                      (supplier_portal.trim() === '' ? ' is-error' : '')
                    }
                  >
                    <label>
                      Supplier Portal <br /> (URL)
                    </label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="supplier_portal"
                          value={supplier_portal}
                        />
                      </Section>

                      <Section className="message">
                        {supplier_portal.trim() === '' ? STRING.INVALID : ''}
                      </Section>
                    </Section>
                  </Section>

                  <Section className="form-group-header">Buyer Admin</Section>

                  <Section
                    className={
                      'form-group' +
                      (admin_buyer_full_name.trim() === '' ? ' is-error' : '')
                    }
                  >
                    <label>Full Name</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="admin_buyer_full_name"
                          value={admin_buyer_full_name}
                        />
                      </Section>

                      <Section className="message">
                        {admin_buyer_full_name.trim() === ''
                          ? STRING.INVALID
                          : ''}
                      </Section>
                    </Section>
                  </Section>

                  <Section
                    className={
                      'form-group' +
                      (this.state.admin_buyer_emailValid
                        ? ''
                        : this.state.formValid
                        ? ''
                        : ' is-error')
                    }
                  >
                    <label>Email</label>

                    <Section className="form-group-control with-button">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          id="name"
                          type="text"
                          onChange={this.handleUserInput}
                          name="admin_buyer_email"
                          value={admin_buyer_email}
                          className={
                            this.state.admin_buyer_emailValid
                              ? ''
                              : this.state.formValid
                              ? ''
                              : 'is-error'
                          }
                        />

                        <Button
                          className="theme-blue resend-activation-email"
                          onClick={() => {
                            this.state.resendEmail === false
                              ? null
                              : this.resendEmail()
                          }}
                          disabled={
                            this.state.resendEmail === false ? true : false
                          }
                        >
                          {!this.state.resendEmailLoading ? (
                            'Resend Activation Email'
                          ) : (
                            <span className="loader"></span>
                          )}
                        </Button>
                      </Section>

                      {this.state.admin_buyer_email === '' && (
                        <Section className="message">{STRING.INVALID}</Section>
                      )}
                      {!this.state.admin_buyer_emailValid &&
                        this.state.admin_buyer_email !== '' && (
                          <Section className="message">
                            {STRING.EMAIL_INVALID}
                          </Section>
                        )}

                      {this.state.admin_buyer_emailValid &&
                        this.state.admin_buyer_email !== '' && (
                          <Section className="message">{''}</Section>
                        )}
                    </Section>
                  </Section>

                  <Section
                    className={
                      'form-group' +
                      (admin_buyer_license === ''
                        ? ' is-error'
                        : !admin_buyer_licenseValidate && requireActive
                        ? ' is-error'
                        : '')
                    }
                  >
                    <label>
                      No. of <br /> license user
                    </label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          onChange={this.handleUserInput}
                          name="admin_buyer_license"
                          value={admin_buyer_license}
                        />

                        <Section className="note">
                          (No. of license users: {license - remain_license} /{' '}
                          {license})
                        </Section>
                      </Section>

                      <Section className="message">
                        {admin_buyer_license === ''
                          ? STRING.INVALID
                          : !admin_buyer_licenseValidate && requireActive
                          ? STRING.NO_INVALID
                          : ''}
                      </Section>
                    </Section>
                  </Section>

                  <Section className="form-group">
                    <label>Active</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Switcher
                          onChange={() => this.togleSwitchActive(is_active)}
                          checked={is_active}
                          disabled={this.state.disabledToggle}
                        />
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
                <Section className="form-actions">
                  <Button
                    className="theme-border-gray"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.BUYER_MANAGEMENT.LINK)
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    className="theme-green"
                    onClick={() => {
                      company_name.trim() === '' || canSave === false
                        ? ''
                        : this.onFormSubmit()
                    }}
                    disabled={
                      company_name.trim() === '' || canSave === false
                        ? true
                        : false
                    }
                  >
                    Save
                  </Button>
                </Section>
              </React.Fragment>
            )}
          </Section>
        </Section>
      </BuyerEditFormStyle>
    )
  }
}
